<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">体检项目编辑</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-form :model="editForm" :rules="rules" ref="editForm">
                    <div>
                        <el-row>
                            <el-col :span="24" class="item">
                                <el-form-item label="科室检查项目" required prop="inspectionItemCode">
                                    <el-select v-model="editForm.inspectionItemCode" placeholder="请选择科室检查项目" style="width:100%" >
                                        <el-option
                                                v-for="item in inspectionItemList"
                                                :key="item.inspectionItemCode"
                                                :label="item.name"
                                                :value="item.inspectionItemCode">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" class="item">
                                <el-form-item label="状态" required prop="status">
                                    <el-select v-model="editForm.status" placeholder="请选择状态" style="width:100%" >
                                        <el-option
                                                v-for="item in statusValue"
                                                :key="item[0]"
                                                :label="item[1]"
                                                :value="item[0]">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('editForm')">编辑</el-button>
            </div>
        </div>
        
    </div>
</template>

<script>
    import {timeStr} from "@/common/times";
    import {getStaffCode} from "@/utils/auth";
    import {hex_md5} from "@/common/Base64MD5";
   
    export default {
        name: "Edit",
        props:['inspectionItemList'],
        data() {
            return {
                loading: false,
                imageUrl:"",
                editForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    testItemCode:'',
                    inspectionItemCode:'',
                    status:''
                },
                statusValue:[[1,'正常'],[2,'废弃']],
                rules:{
                    inspectionItemCode:[
                        { required: true, message: '请选择标题', trigger: 'blur' },
                    ]
                }
            }
        },
        methods: {
            init(row){
                this.editForm.testItemCode=row.testItemCode
                this.editForm.inspectionItemCode=row.inspectionItemCode
                this.editForm.status=row.status
            },
            closeSelf() {
                this.$emit("closeEdit");
            },
            handelIncrease(step) {
                this.editForm.detail=step
            },
            
            confirm(editForm){
                this.$refs[editForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },
            addSubmit(){
                this.loading = true;
                this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"TestItem/Edit",
                    data: this.editForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
        }
    }
</script>

<style  lang="scss" scoped>
    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;
    .modal {
        background-color: #fff;
        box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        overflow-x:auto;
        display: flex;
        flex-direction: column;
        border-radius: 10px;
        width: 420px;

    .modal-header {
        border-bottom: 1px solid #eee;
        color: #313131;
        justify-content: space-between;
        padding: 10px;
        display: flex;
    }
    .modal-body {
        position: relative;
        padding: 20px 0px;
        z-index: 99;
        overflow-y:auto ;
        height: 100%;
    }
    .modal-footer {
        border-top: 1px solid #eee;
        justify-content: flex-end;
        padding: 15px;
        display: flex;
    }


    }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }
</style>